import React, { Suspense,  useState, useRef } from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import { shallowEqual, useSelector } from "react-redux";
import { LayoutSplashScreen } from "../_metronic/layout";

// Import pages
import { SecurityDashboard } from "./modules/Dashbord/pages/SecurityDashboard";
import { AccessControl } from "./modules/AccessControl/pages/AccessControl";
import { Incidents } from './modules/Incidents/pages/Incidents.jsx';
import { IncidentDetail } from './modules/Incidents/pages/IncidentDetail.jsx';
import { ThreatAlerts } from './modules/ThreatAlerts/pages/ThreatAlerts';
import { Blacklist } from './modules/Blacklist/pages/Blacklist';
import { Members } from './modules/Members/pages';
import { Visitors } from './modules/Visitors/pages';
import { ReportsPage } from './modules/Report/pages/ReportsPage.jsx';
import { NetworkIntelligence } from './modules/NetworkIntelligence/pages/NetworkIntelligence';
import { SettingsPage } from './modules/Settings/pages';
import { Spaces } from './modules/Spaces/pages';
import { Management } from './modules/Management/pages';
import { Integrations } from './modules/Integrations/pages/Integrations';
import { OAuthCallback } from './modules/Integrations/pages/OAuthCallback';
import { DevicesPage, DeviceDetail } from './modules/Devices';

// Event Organizer pages
import { EventsOverview } from './modules/Events/pages/EventsOverview';
import { EventsList }     from './modules/Events/pages/EventsList';
import { EventDetail }    from './modules/Events/pages/EventDetail';
import { EventForm }      from './modules/Events/pages/EventForm';
import { EventOrders }    from './modules/Events/pages/EventOrders';
import { WalletPage }     from './modules/Wallet/pages/WalletPage';


// Notifications
import Notification from 'react-web-notification';
import useSound from 'use-sound';
import boopSfx from '../sound/sound.mp3';

// const DocsPage = lazy(() =>
//   import("./modules/Docs/pages")
// );

export default function BasePage() {
  const clickRef = useRef();

  const org = useSelector(s => s.auth.organization, shallowEqual);
  const isEventOrganizer = org?.type === 'event_organizer';

  const [play] = useSound(boopSfx);
  const [options] = useState({});
  const [ignore] = useState(false);
  const [title] = useState('');

  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Notification
        ignore={ignore}
        timeout={5000}
        title={title}
        options={options}
      />
      <a
        ref={clickRef}
        onClick={() => play()}
        href="#"
        style={{ display: 'none' }}
      />

      <Routes>
        {/* Root redirect — event organizers land on /events, everyone else on /dashboard */}
        <Route path="/" element={<Navigate to={isEventOrganizer ? '/events' : '/dashboard'} replace />} />

        {/* Main Dashboard - Security Intelligence */}
        <Route path="/dashboard" element={<SecurityDashboard />} />

        {/* Access Control - Visitor Validation */}
        <Route path="/access-control" element={<AccessControl />} />

        {/* Security Section */}
        <Route path="/incidents" element={<Incidents />} />
        <Route path="/incidents/:incidentId" element={<IncidentDetail />} />
        <Route path="/threat-alerts" element={<ThreatAlerts />} />
        <Route path="/blacklist" element={<Blacklist />} />

        {/* Management Section */}
        <Route path="/members/*" element={<Members />} />
        <Route path="/visitors/*" element={<Visitors />} />
        <Route path="/spaces/*" element={<Spaces />} />

        <Route path="/operations/*" element={<Management />} />


        {/* Intelligence Section */}
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/network-intelligence" element={<NetworkIntelligence />} />
        <Route path="/devices" element={<DevicesPage />} />
        <Route path="/devices/:deviceId" element={<DeviceDetail />} />
        <Route path="/integrations" element={<Integrations />} />
        <Route path="/integrations/oauth/callback" element={<OAuthCallback />} />
        {/* System Section */}
        <Route path="/settings/*" element={<SettingsPage />} />
        {/* <Route path="/docs/*" element={<DocsPage />} /> */}

        {/* Event Organizer routes */}
        <Route path="/events"                          element={<EventsOverview />} />
        <Route path="/events/list"                     element={<EventsList />} />
        <Route path="/events/orders"                   element={<EventOrders />} />
        <Route path="/events/new"                      element={<EventForm />} />
        <Route path="/events/:eventId"                 element={<EventDetail />} />
        <Route path="/events/:eventId/edit"            element={<EventForm />} />
        <Route path="/events/:eventId/orders"          element={<EventOrders />} />
        <Route path="/wallet"                          element={<WalletPage />} />

        {/* Legacy Routes - Navigate to new paths */}
        <Route path="/residents" element={<Navigate to="/members" replace />} />
        <Route path="/zones" element={<Navigate to="/locations" replace />} />
        <Route path="/access" element={<Navigate to="/access-control" replace />} />

        {/* 404 - Navigate to error page */}
        <Route path="*" element={<Navigate to="/error/error-v1" replace />} />
      </Routes>
    </Suspense>
  );
}